import { gql } from "@apollo/client";

export const getKEKReInsurers = gql`
  query KEKReinsurers {
    count: getReinsurersCount
    rows: reinsurers {
      re_abbrv
      re_company_email
      re_company_name
      re_company_website
      reinsurer_address {
        country
        region
        reinsurer_address_id
        street
        suburb
      }
      reinsurer_id
      reinsurer_representatives {
        reinsurer_representative_id
      }
    }
  }
`;

export const getKEKReInsurer = gql`
  query KEKReinsurer($reinsurerId: ID!) {
    reinsurer(reinsurer_id: $reinsurerId) {
      re_company_name
      reinsurer_id
      re_company_email
      re_company_website
      re_abbrv
      reinsurer_address {
        reinsurer_address_id
        street
        suburb
        region
        country
      }
      reinsurer_overview {
        brokerage_chart
        total_brokerage_amt
        total_closed
        total_fac_premium
        total_nic_tax
        total_paid
        total_pending
        total_unpaid
        total_withholding_tax
      }
    }
  }
`;

export const getKEKReinsurerAssociates = gql`
  query GetKEKReinsurerAssociates(
    $reinsurerId: ID!
    $pagination: Pagination
    $search: String
  ) {
    getReinsurerAssociates(
      reinsurer_id: $reinsurerId
      pagination: $pagination
      search: $search
    ) {
      reinsurer_representative_id
      reinsurersreinsurer_id
      rep_first_name
      rep_last_name
      rep_primary_phonenumber
      rep_secondary_phonenumber
      rep_email
      position
      reinsurer {
        re_abbrv
        re_company_email
        re_company_name
        re_company_website
        reinsurer_id
      }
    }
    count: getReinsurerAssociatesCount(reinsurer_id: $reinsurerId)
  }
`;
